import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RmmDateTimeFormatModule } from 'mbs-ui-shared@components/date-time-format/rmm-date-time-format.module';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DirectivesModule } from 'mbs-ui-shared/src/lib/directives/directives.module';
import { UtilsModule } from 'mbs-ui-shared@utils/utils.module';
import { I18NextModule } from 'angular-i18next';
import { MbsUiKitModule } from 'mbs-ui-kit';
import { StoreTypes } from "mbs-ui-shared@store/storeTypes.enum";
import { IterationCtrlButtonModule } from 'mbs-ui-shared@modules/iteration-ctrl-button/iteration-ctrl-button.module';
import { UtilitySelectionModalModule } from 'mbs-ui-shared@modules/utility-selection-modal/utility-selection-modal.module';
import { SnmpService } from './services/snmp.service';
import { SnmpCustomNotificationsComponent } from './snmp-custom-notifications.component';
import { SnmpCustomNotificationsEffects } from './store/alert/effects';
import { smnpAlertDeviceReducer } from './store/alert/reducer';

@NgModule({
  imports: [
    CommonModule,
    RmmDateTimeFormatModule,
    EffectsModule.forFeature([SnmpCustomNotificationsEffects]),
    FormsModule,
    I18NextModule,
    MbsUiKitModule,
    NgbDropdownModule,
    NgbTooltipModule,
    ReactiveFormsModule,
    IterationCtrlButtonModule,
    StoreModule.forFeature(StoreTypes.SnmpAlerts, smnpAlertDeviceReducer),
    DirectivesModule,
    UtilsModule,
    UtilitySelectionModalModule
  ],
  declarations: [SnmpCustomNotificationsComponent],
  exports: [SnmpCustomNotificationsComponent],
  providers: [SnmpService]
})
export class SnmpCustomNotificationModule {}
